import React from 'react';

export const WellTestingTabs = ({ activeTab, setActiveTab }) => {
    return (
        <div className="mb-4 border-b">
            <nav className="-mb-px flex space-x-8">
                <button
                    onClick={() => setActiveTab('map')}
                    className={`py-2 px-1 border-b-2 font-medium text-sm ${
                        activeTab === 'map'
                            ? 'border-blue-500 text-blue-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                >
                    Map Visualization
                </button>
                <button
                    onClick={() => setActiveTab('upload')}
                    className={`py-2 px-1 border-b-2 font-medium text-sm ${
                        activeTab === 'upload'
                            ? 'border-blue-500 text-blue-600'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                >
                    Upload Test Results
                </button>
            </nav>
        </div>
    );
};
